import { FormControl, FormHelperText } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styled from 'styled-components/macro';
import { border } from 'variables/general';

export const ModalContent = styled.div `
  display: flex;
  flex-grow: 1;
  min-height: 0;
`;

export const Header = styled.div `
  display: flex;
  align-items: center;
  padding-bottom: 1.5em;
  border-bottom: ${border};
`;

export const HeaderCopy = styled.div `
  flex-grow: 1;
`;

export const HeaderTitle = styled.h4 `
  margin-bottom: 0.5em;
`;

export const HeaderAddress = styled.p `
  font-size: 0.75em;
`;

export const OverviewDetails = styled.div `
  display: flex;
  padding: 1.5em 0;
  border-bottom: ${border};
`;

export const Detail = styled.div ``;

export const DetailLabel = styled.label `
  font-size: 0.625em;
`;

export const DetailValue = styled.h5 `
  margin-top: 0.5em;
`;

export const FormSectionTitle = styled.h4 `
  margin-bottom: 1.5em;

  &:not(:first-of-type) {
    margin-top: 3em;
  }
`;

export const FormWrapper = styled.div `
  min-height: 0;
  margin: 3em 0;
  overflow-y: auto;
`;

export const GridContainer = styled.div `
  display: grid;
  grid-row-gap: 1em;
  grid-column-gap: 1em;
  grid-template-columns: 1fr;

  @media (min-width: 52em) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledField = withStyles(() => ({ root: { margin: '.75em 0' } }))(
    FormControl,
);

export const StyledHelperText = withStyles(() => ({
    root: {
        position: 'absolute',
        bottom: ({ bottom }) => (bottom ? `${bottom}em` : '1em'),
    },
}))(FormHelperText);